import { useEffect } from "react";
import useNetworkStatus from "./useNetworkStatus";
import { toast } from "../components/Toast/toast";

const NetworkWatcher = () => {
  const isOnline = useNetworkStatus();

  useEffect(() => {
    if (!isOnline) {
      toast.error("Internet Not Connected! Please check your connection.", {
        toastId: "network-error", // ensures only one toast
      });
    } else {
      if (toast.isActive("network-error")) {
        toast.dismiss("network-error"); // only dismiss if it exists
      }
    }
  }, [isOnline]);

  return null;
};

export default NetworkWatcher;
